export { default } from "./DeleteOrder.page";
